var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34434 1.31626C7.53131 1.54134 7.63635 1.84657 7.63635 2.16483C7.63635 2.4831 7.53131 2.78833 7.34434 3.01341L2.4074 8.95463L7.34434 14.8959C7.52602 15.1222 7.62654 15.4254 7.62427 15.7401C7.622 16.0548 7.51711 16.3558 7.33219 16.5784C7.14727 16.8009 6.89712 16.9271 6.63562 16.9299C6.37411 16.9326 6.12218 16.8116 5.93407 16.593L0.292003 9.8032C0.105027 9.57812 -1.09673e-05 9.27289 -1.09673e-05 8.95463C-1.09673e-05 8.63637 0.105027 8.33114 0.292003 8.10606L5.93407 1.31626C6.1211 1.09125 6.37474 0.964844 6.63921 0.964844C6.90367 0.964844 7.15731 1.09125 7.34434 1.31626Z",
    fill: "#004CBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.2b8d55a6a13675abd6f390070a3a4990.svg";
export { ForwardRef as ReactComponent };